import { render, staticRenderFns } from "./Gesundheitspruefung.vue?vue&type=template&id=1018f6bf&"
import script from "./Gesundheitspruefung.vue?vue&type=script&lang=js&"
export * from "./Gesundheitspruefung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports